// removed by extract-text-webpack-plugin
module.exports = {"container":"_3uF1_A0lcAQMC-n7i5OoV9","delete":"_10oQ_RPsRX8Uzp1hx6VBAO","contactlist":"_1YCtJDhs5D7-D047iKCkIp"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/BioSigners/styles.css
// module id = 3037
// module chunks = 0